import MatchedMap from 'utilities/src/matchedMap';

import { InputStateEnum } from '../../../utils/state';
import { InputThemeEnum, type InputThemeProps } from '../../../utils/themes';

/**
 * MessageHelper Common Classes
 */

const messageHelperTextClasses = 'site-paragraph-xs';

/**
 * MessageHelper Theme State Classes
 */

const messageHelperTextDarkStateClassesMap = new MatchedMap([
  [InputStateEnum.Default, 'text-site-neutrals-200'],
  [InputStateEnum.Disabled, 'text-site-neutrals-500'],
  [InputStateEnum.Error, 'text-site-neutrals-200'],
  [InputStateEnum.Success, 'text-site-success-500'],
]);

const messageHelperTextLightStateClassesMap = new MatchedMap([
  [InputStateEnum.Default, 'text-site-neutrals-500'],
  [InputStateEnum.Disabled, 'text-site-neutrals-200'],
  [InputStateEnum.Error, 'text-site-neutrals-500'],
  [InputStateEnum.Success, 'text-site-success-700'],
]);

const messageHelperTextStateClassesMap = new MatchedMap([
  [InputThemeEnum.Dark, messageHelperTextDarkStateClassesMap],
  [InputThemeEnum.Light, messageHelperTextLightStateClassesMap],
]);

/**
 * Blog Theme
 */

const inputMessageHelperBlogTheme = ({
  inputTheme,
  inputState,
}: Pick<InputThemeProps, 'inputTheme' | 'inputState'>) => ({
  messageHelperTextThemeClasses: messageHelperTextClasses,
  messageHelperTextStateThemeClasses: messageHelperTextStateClassesMap
    .get(InputThemeEnum[inputTheme])
    .get(InputStateEnum[inputState]),
});

export default inputMessageHelperBlogTheme;
